import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientPreferredPharmacies = (state, patientId) =>
  allModelsSelector(state, 'PatientPreferredPharmacy', (p) => p.patientId === patientId);
